<template>
  <div class="bto-sb-widget bto-sb-widget-mybets-checker" v-if="showWidget && (showMyBetsBtn || showFreebetsBtn)">
    <div class="bto-sb-widget-title">
      <h3>{{ t("Mobile.MyBets") }}</h3>
    </div>
    <div class="bto-sb-widget-content">
      <button
        v-if="showMyBetsBtn"
        class="bto-sb-form-btn bto-sb-btnmybets"
        @click.prevent="viewAllMyBets($event)">
        <span class="bto-app-history"></span>{{ t("Mobile.MyBets") }}
      </button>
      <button v-if="showFreebetsBtn" class="bto-sb-form-btn" @click.prevent="viewAllFreeBets()">
        <span class="bto-app-freebet"></span>{{ t("FB.MakeFreebet") }}
      </button>
    </div>
  </div>
</template>

<script>
  import { EventBus } from '../../../services/event-bus-service';
  import { openModal } from '@bto-services/modal';
  import { freebetStore } from '@bto-services/betslip-core';
  import { userLoggedIn } from '@bto-services/user';

  export default {
    name: 'BetButtonsWidget',
    props: {
      myBetsPopup: {
        type: Boolean,
        default: true,
        label: 'Open my bets in a popup'
      },
      showMyBetsBtn: {
        type: Boolean,
        default: true,
        label: 'Show MyBets Button'
      },
    },
    computed: {
      showFreebetsBtn() {
        return freebetStore.freebets.length > 0;
      },
      showWidget() {
        return userLoggedIn();
      },
    },
    methods: {
      viewAllMyBets(e) {
        if (this.myBetsPopup) {
          EventBus.$emit('allmybets', e);
        } else {
          this.$router.push({ name: 'myBetsHistory' });
        }
      },
      viewAllFreeBets() {
        openModal({
          title: 'BetSlip.FreeBet',
          modalClass: 'bto-sb-modalpopup-md bto-sb-modalfreebets',
          contentComponent: 'FreebetModal',
        });
      },
    },
  };
</script>
